// extracted by mini-css-extract-plugin
export default {"card":"Cancelled_card__i0rdX","inner_card":"Cancelled_inner_card__mVaKq"};